<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Import Learner Fees</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" align="center">
                <v-col cols="12" sm="4" md="4">
                    <v-autocomplete rounded :items="ay_list" v-model="ay" item-text="ay" item-value="id"
                        label="Academic Year" dense outlined placeholder="Select Academic Year"></v-autocomplete>
                </v-col>
                <!-- <v-col cols="12" sm="4" md="4">
                  <v-autocomplete rounded :items="std_list" v-model="std" item-text="name" item-value="id" label="Standard" dense outlined placeholder="Select Standard"></v-autocomplete>
              </v-col> -->
            </v-row>

            <v-row justify="center" align="center" v-if="ay != null">
                <v-col cols="12" sm="4" md="4" class="pt-5 mt-2">
                    <v-file-input placeholder="CSV of student data" prepend-icon="mdi-file" label="Student Data"
                        show-size flat rounded outlined dense v-model="file"></v-file-input>
                </v-col>
                <v-col cols="12" sm="4" md="4" class="pt-0 mt-0">
                    <a
                        href="https://eduplusschool.s3.ap-south-1.amazonaws.com/sample_csv_files/csv_files/learnerspreviousfeesentry.csv">
                        <v-btn :loading="loading3" :disabled="loading3" color="blue-grey" outlined
                            class="ma-2 white--text downbtn button" @click="loader = 'loading3'">
                            Download import CSV format
                            <v-icon right dark>mdi-cloud-download</v-icon>
                        </v-btn>
                    </a>
                </v-col>
            </v-row>

            <v-row justify="center" align="center">
                <!-- <v-btn class="button" @click="submitFile" :loading="output_load">Submit</v-btn> -->
                <v-btn class="button" @click="submitFile">Submit</v-btn>
            </v-row>

            <!-- shiv new code -->
            <v-col cols="12" sm="12" md="12">
                <template v-if="load == false">
                    <v-simple-table class="mytable">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">GR No</th>
                                    <th class="text-left">Bruch 1</th>
                                    <th class="text-left">Term Fee 1</th>
                                    <th class="text-left">Exam Fee 1</th>
                                    <th class="text-left">Robotics 1</th>
                                    <th class="text-left">Add fees Components</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>VVEPP00010</td>
                                    <td>400</td>
                                    <td>400</td>
                                    <td>300</td>
                                    <td>100</td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td class="mandatory">Mandatory</td>
                                    <td class="mandatory">Mandatory</td>
                                    <td class="mandatory">Mandatory</td>
                                    <td class="mandatory">Mandatory</td>
                                    <td class="mandatory">Mandatory</td>
                                    <td class="mandatory">Mandatory (If you add)</td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </template>
            </v-col>
            <!-- shiv code end -->

            <span v-if="statuslist != ''">
                <v-col cols="12" sm="12" md="12" v-if="statuslist.statuslist[0].faillist != ''">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Failed Students Data</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <download-excel class="ma-2 no-display" color="primary" dark
                        :data="statuslist.statuslist[0].faillist" :fields="xls_header1" worksheet="Failed Data"
                        name="Failed_Data.xls">
                        <v-btn class="ma-2 no-display" tile outlined color="success">
                            <v-icon left>mdi-file-excel</v-icon> Excel
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                    </download-excel>
                    <template>
                        <v-data-table dense :headers="headers1" :items="statuslist.statuslist[0].faillist" sort-by
                            class="elevation-1 mytable" :search="search"></v-data-table>
                    </template>
                </v-col>

                <v-col cols="12" sm="12" md="12" v-if="statuslist.statuslist[0].statuslist != ''">
                    <template>
                        <v-data-table dense :headers="headers" :items="statuslist.statuslist[0].statuslist" sort-by
                            class="elevation-1 mytable" :search="search">
                            <template v-slot:top>
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Success Students Data</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-toolbar flat dense color="white" align="center" justify="center">
                                    <download-excel class="ma-2 no-display" color="primary" dark
                                        :data="statuslist.statuslist[0].statuslist" :fields="xls_header"
                                        worksheet="Success_Data" name="Success_Data.xls">
                                        <v-btn class="ma-2 no-display" tile outlined color="success">
                                            <v-icon left>mdi-file-excel</v-icon> Excel
                                            <v-icon right>mdi-download</v-icon>
                                        </v-btn>
                                    </download-excel>
                                </v-toolbar>
                            </template>
                        </v-data-table>
                    </template>
                </v-col>
            </span>
        </v-card>
        <div class="text-center">
            <v-dialog v-model="output_load" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>
<script>
  import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
      data() {
          return {
              file: null,
              statuslist: [],
              load: false,
              loading3: false,
              search: "",
              snackbar: false,
              snackbar_msg: "",
              color: "",
              snackbar: false,
            //   extraBreadcrumbItems: [


            //   ],
            //   breadcrumbClass: "breadcrumb-style1",
              std_list: [],
              ay_list: null,
              ay: null,
              list_display: null,
              std: null,
              xls_header: {
                  SR_No: "sr.no",
                  PRN_No: "grno",
                  Status: "status",
                  Amount: "amount",
              },
              headers: [
                  { text: "Sr.NO", value: "sr.no" },
                  { text: "PRN No", value: "grno" },
                  { text: "Status", value: "status" },
                  { text: "Amount", value: "amount" },
              ],
              xls_header1: {
                  PRN_No: "grno",
                  Status: "status",
                  Remark: "remark",
              },
              headers1: [
                  { text: "PRN No", value: "grno" },
                  { text: "Status", value: "status" },
                  { text: "Reason", value: "remark" },
              ],
              output_load: false,
          };
      },

      methods: {
          showSnackbar(clr, msg) {
              this.snackbar = true;
              this.color = clr;
              this.snackbar_msg = msg;
          },
          submitFile() {
              this.load = true;
              if (this.file == null) {
                  alert("Please select the file!");
              } else {
                  this.output_load = true;
                  let formData = new FormData();
                  //console.log(this.file.size)
                  formData.append("file", this.file);
                  // formData.append("std", this.std);
                  formData.append("ay", this.ay);

                  //console.log(formData)
                  axios
                      .post("InstallmentStructureDetails/importHome", formData, {
                          headers: {
                              "Content-Type": "multipart/form-data",
                          },
                      })
                      .then((res) => {
                          if (res.data.status == "NO") {
                              this.showSnackbar("#b71c1c", res.data.snackbar); // show snackbar
                          } else {
                              this.statuslist = res.data;
                              this.output_load = false;
                              this.showSnackbar("#4caf50", "Data Imported Successfully..."); // show snackbar on success
                          }
                      })
                      .catch(function () {
                          console.log("FAILURE!!");
                          this.output_load = false;
                      })
                      .finally(() => {
                          this.output_load = false;
                      });
                  //     }
              }
          }, //end of the fuction

          /*
      Handles a change on the file upload
    */
      },
      mounted() {
          axios
              .post("/InstallmentStructureDetails/importLearnerSelectionHome")
              .then((res) => {
                  this.std_list = res.data.std_list;
                  this.ay_list = res.data.ay_list;
              })
              .catch((error) => {
                  this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
              })
              .finally(() => {});
      },
  };
</script>
<style scoped>
  .downbtn {
      float: right;
  }
  .mytable2 /deep/ thead th {
      background: #0f2027; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }

  /* new css */
  table,
  th {
      padding: 10px;
      border: 1px solid rgb(206, 200, 200);
      border-collapse: collapse;
      background: #0f2027; /* fallback for old browsers */
      background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
      background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
      background-color: #0f2027 !important;
      color: white !important;
      font-weight: bold !important;
      white-space: nowrap !important;
      text-align: center;
  }
  .mandatory {
      color: red;
  }
</style>
